// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tabs_tab__28Mkm","error":"Tabs_error__2NsO6","tabPanel":"Tabs_tabPanel__322Af"};